import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import BillReportsContent from '../BillReportsContent';
import { fetchBillsData } from '../../../store/slices/billReportsSlice';

const BillReports = () => {
    const dispatch = useDispatch();

    // Get branchId from localStorage for MANAGER role
    const storedBranchId = localStorage.getItem('branchid') || '';

    // Auto-fetch data on mount with branch from localStorage
    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate());

        dispatch(
            fetchBillsData({
                fromDate,
                toDate,
                branchId: storedBranchId,
                status: ''
            })
        );
    }, [dispatch, storedBranchId]);

    return <BillReportsContent />;
};

export default BillReports;
